export class LeistungsEditorDialog {
  Template: Array<{Titel: string; Fakten: any}>;
  Data: any;
}
